import React from 'react';
import { motion } from 'framer-motion';
export function Gallery() {
  // Using high quality food images from Unsplash that fit the descriptions
  const images = [{
    url: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&q=80&w=800',
    alt: 'Pan de campo'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/7hTSdRr5pGsHguYZbPEASj/Empanadas-de-pollo-im.jpg',
    alt: 'Empanadas'
  }, {
    url: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&q=80&w=800',
    alt: 'Pizza'
  }, {
    url: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?auto=format&fit=crop&q=80&w=800',
    alt: 'Postres'
  }, {
    url: 'https://images.unsplash.com/photo-1509365465985-25d11c17e812?auto=format&fit=crop&q=80&w=800',
    alt: 'Facturas'
  }];
  return <section className="py-20 bg-gray-50 overflow-hidden" data-id="element-51">
      <div className="max-w-7xl mx-auto px-6 mb-12 text-center" data-id="element-52">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900" data-id="element-53">
          Un vistazo a lo que vas a preparar
        </h2>
      </div>

      {/* Auto-scrolling gallery effect using framer motion or simple CSS */}
      <div className="flex overflow-x-auto hide-scrollbar gap-6 px-6 pb-8 snap-x" data-id="element-54">
        {images.map((img, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="min-w-[280px] md:min-w-[350px] aspect-[4/5] rounded-3xl overflow-hidden shadow-lg snap-center relative group" data-id="element-55">
            <img src={img.url} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-56" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6" data-id="element-57">
              <span className="text-white font-serif text-xl font-medium" data-id="element-58">
                {img.alt}
              </span>
            </div>
          </motion.div>)}
      </div>
    </section>;
}